(()=>{
  function init(){
    document.querySelectorAll('[data-black-month-deadline]:not([data-black-month-ready])').forEach(bar=>{
      bar.dataset.blackMonthReady='true';
      const firstDeadline=Date.parse(bar.dataset.blackMonthDeadline);
      const cycle=7*24*60*60*1000;
      const timer=bar.querySelector('time');
      if(!Number.isFinite(firstDeadline)||!timer)return;
      let interval;
      function update(){
        if(!bar.isConnected){clearInterval(interval);return;}
        const now=Date.now();
        const cycles=now>=firstDeadline?Math.floor((now-firstDeadline)/cycle)+1:0;
        const deadline=firstDeadline+cycles*cycle;
        const remaining=Math.max(0,Math.ceil((deadline-now)/1000));
        const days=Math.floor(remaining/86400);
        const parts=[Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];
        timer.textContent=days+'g '+parts.map(n=>String(n).padStart(2,'0')).join(':');
        timer.dateTime=new Date(deadline).toISOString();
      }
      update();interval=setInterval(update,1000);
    });
  }
  init();
  if(!window.goBlackMonthReady){window.goBlackMonthReady=true;document.addEventListener('shopify:section:load',init)}
})();
